import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import "./ViewPage.css";
import axios from "axios";

const ViewOD = () => {
  const { od_id } = useParams();
  const navigate = useNavigate();

  const [odData, setOdData] = useState(null);
  const [status, setStatus] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // const odStatus = localStorage.getItem("od_status");
  const odStatus = Number(
    (localStorage.getItem("od_status") || "").replace(/"/g, "")
  );
  const desigName = localStorage.getItem("desig_name").replace(/"/g, "");
  // console.log("desigName",desigName);
  useEffect(() => {
    axios.post(`${API_BASE_URL}od_detail.php`, { od_id: od_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          setOdData(response.data.body);
          setStatus(response.data.body.status);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setOdData([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setOdData([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  const handleStatusChange = (e) => setStatus(e.target.value);

  const handleStatusUpdate = () => {
    // TODO: send update to backend
    console.log(`Status for OD ID ${od_id} updated to: ${status}`);
    alert(`Status updated to "${status}"`);
  };

  if (!odData) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">View OD Assignment</h2>
        <Row>
          <Col>
            <div className="not-found-box">Loading...</div>
          </Col>
        </Row>
      </Container>
    );
  }

  const fields = [
    { label: "Title", value: odData.od_name },
    // { label: "Description", value: odData.description },
    { label: "Assigned To", value: odData.assigned_to_name },
    // { label: "Assigned By", value: odData.assigned_by_name },
    // { label: "Priority", value: odData.priority },
    { label: "Due Date", value: odData.due_date },
    { label: "From Time", value: odData.from_time },
    { label: "To Time", value: odData.to_time },
    // { label: "Created At", value: odData.createdAt },
    // { label: "Updated At", value: odData.updatedAt },
  ];
  // console.log("od name ",odData.od_name);
  // console.log("desigName",desigName);
  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">View OD Assignment</h2>

      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          {/* Left column kept for consistent layout */}
          <div className="customer-photo-wrap" aria-hidden />

          <div className="customer-details-table-wrapper">
            <table
              className="customer-view-table"
              role="table"
              aria-label={`OD details for ${odData.od_name}`}
            >
              {/* <thead>
                <tr>
                  <th style={{ width: "36%" }}>Field</th>
                  <th style={{ width: "64%" }}>Value</th>
                </tr>
              </thead> */}
              <tbody>
                {fields.map((f, i) => (
                  <tr key={i}>
                    <td className="field-cell">{f.label}</td>
                    <td className="value-cell">{f.value}</td>
                  </tr>
                ))}
                {odStatus == "1" &&
                  // ((odData.od_name == "Correspondent" &&
                  //   desigName == "Correspondent") ||
                  //   (odData.od_name != "Correspondent" &&
                  //     (desigName == "Correspondent" ||
                  //       desigName != "Correspondent"))) &&
                  ((odData.od_name == "Secretary" &&
                    desigName == "Secretary") ||
                    (odData.od_name != "Secretary" &&
                      (desigName == "Secretary" ||
                        desigName != "Secretary"))) &&
                  (
                    <tr>
                      <td className="field-cell">Status</td>
                      <td className="value-cell">
                        <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
                          <select
                            className="form-select"
                            style={{ width: "auto", minWidth: 180 }}
                            value={status}
                            onChange={handleStatusChange}
                          >
                            <option value="Submitted">Submitted</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                          </select>
                          <Button variant="primary" size="sm" onClick={handleStatusUpdate}>
                            Update
                          </Button>
                        </div>
                      </td>
                    </tr>)
                }
                {odData.od_name != "Secretary" && (
                  <tr>
                    <td className="field-cell">Location</td>
                    <td className="value-cell">
                      <div style={{ height: 300, width: "100%" }}>
                        <iframe
                          title="OD Location Map"
                          width="100%"
                          height="100%"
                          frameBorder="0"
                          style={{ border: 0 }}
                          // src={`https://www.google.com/maps?q=${encodeURIComponent(odData.location)}&output=embed`}
                          src={`https://www.google.com/maps?q=${odData.latitude},${odData.longitude}&z=15&output=embed`}
                          allowFullScreen
                        />
                      </div>
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ViewOD;
